// src/app/deviceId.ts
// A random id for this browser, sent as X-Device-Id so the server can tell
// a sign-in from a new device (and only then email a sign-in alert). It
// identifies nothing about the person or the device itself.

const KEY = "fsl-device-id";
let cached: string | null = null;

const randomId = () =>
  typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

export function deviceId(): string {
  if (cached) return cached;
  try {
    cached = localStorage.getItem(KEY);
    if (!cached) {
      cached = randomId();
      localStorage.setItem(KEY, cached);
    }
  } catch {
    // Storage blocked (private mode): fall back to an id for this visit only
    cached = cached || randomId();
  }
  return cached;
}
